import { posthog } from '@/composables/usePosthog'
import privilegeService from '@/services/privilege.service'

const isAccountOwner = claims => !claims.system_user_id || !!claims.default_merchant_user

export const isStaffSession = claims => claims.staff_impersonation === true

export const personId = (user, claims) =>
  isAccountOwner(claims) ? String(user.attributes.id) : `system_user_${claims.system_user_id}`

const withoutUnset = properties =>
  Object.fromEntries(Object.entries(properties).filter(([, value]) => value !== undefined))

export function personProperties(user, claims) {
  const attributes = user.attributes
  const systemUser = !!claims.system_user_id
  return withoutUnset({
    email: systemUser ? claims.system_user_email : attributes.email,
    name: systemUser ? claims.system_user_name : attributes.user_name,
    handle: attributes.handle,
    user_type: systemUser ? 'system_user' : 'merchant',
    system_user: systemUser,
    system_user_id: claims.system_user_id ?? null,
    country: attributes.country,
    is_account_owner: isAccountOwner(claims),
    role: claims.role?.name ?? null,
    is_admin: systemUser ? !!claims.role?.is_admin : true,
    created_at: systemUser ? claims.system_user_created_at : attributes.created_at,
    merchant_id: attributes.id,
    merchant_handle: attributes.handle,
    merchant_created_at: attributes.created_at,
    platforms: attributes.platforms,
    capabilities: attributes.capabilities,
    time_zone: attributes.time_zone,
    has_stripe_connected_account: attributes.has_stripe_connected_account
  })
}

export const currentPersonId = user => personId(user, privilegeService.getTokenClaims())

export const inStaffSession = () => isStaffSession(privilegeService.getTokenClaims())

export function identifyPerson(user, claims = privilegeService.getTokenClaims()) {
  if (!posthog.__loaded) return
  const id = personId(user, claims)
  if (posthog.get_distinct_id() !== id && posthog.get_property('$user_state') === 'identified') posthog.reset()
  posthog.register({ staff_impersonation: isStaffSession(claims) })
  posthog.identify(id, personProperties(user, claims))
}
